"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const AlertBar = ({ children, className, classNames = [], closeLabel = 'Close', isHidden = false, useLocalStorage = true, localStorageKey = 'alert-bar-closed', alertHash = '1', isClosable, }) => {
    const [hideAlertBar, setHideAlertBar] = (0, react_1.useState)((isHidden === true) ||
        (useLocalStorage === true && localStorage.getItem(localStorageKey) === alertHash));
    return (react_1.default.createElement("div", { className: className ||
            (0, classnames_1.default)('alert-bar', 'alert', hideAlertBar && 'd-none', ...classNames) },
        children,
        isClosable && react_1.default.createElement("button", { type: "button", className: "btn-close", "aria-label": closeLabel, onClick: (e) => {
                if (useLocalStorage) {
                    localStorage.setItem(localStorageKey, alertHash);
                }
                setHideAlertBar(true);
            } })));
};
exports.default = AlertBar;
